import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeDeleteItemPhotosDialog } from "./item-photos-delete-slice";
import { db, storage } from "../../../../../../../../firebase";
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { useEffect, useState } from "react";
import { deleteItemPhotosService, getItemsDataService } from "./item-photos-delete-service";
import { useNavigate } from "react-router-dom";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../../../../../shared/snackbar/snackbar-slice";
import { arrayRemove, doc, updateDoc } from "@firebase/firestore";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
      color: "#111111",
      '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
    pieces: 0,
    original_price: 0,
    increase: 0,
    unit_price: 0,
    rent_price: 0,
    rent_percent: 0,
    deposit: 0,
    deposit_percent: 0,
    type: "",
    status: "",
    category: "",
};

const ItemPhotosDelete = (props) => {
    const classes = useStyles();
    const photoUrl = useSelector((state) => state.itemPhotosDeleteSlice.itemPhotosDelete);
    const showDialog = useSelector((state) => state.itemPhotosDeleteSlice.showDialog);
    const isLoading = useSelector((state) => state.itemPhotosDeleteSlice.isLoading);
    const dispatch = useDispatch();

    const item_id = props.item_id;

    // handle delete
    const handleDeleteSubmit = async (url) => {
        await deleteItemPhotosService(dispatch, db, "items", item_id, url);
        handleDeleteClose();
    };

    // handle close delete
    const handleDeleteClose = () => {
        dispatch(closeDeleteItemPhotosDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Delete Item
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.text}>
                    {`Do you want to delete this photo?`}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => {handleDeleteSubmit(photoUrl)}}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Deleting..."
                        ) : (
                            "Delete"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleDeleteClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemPhotosDelete;